import Sidebar from "../Sidebar/Sidebar";
import AdminNavbar from "../AdminNavbar/AdminNavbar";
import { Outlet, useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import routes from "../routes";
import { useStore } from "../../utilities/appStore";
import { getNavItems } from "../../utilities/orgPanelApiCalls";
import { useAuth } from "react-oidc-context";
import { setAuthHeader } from "../../utilities/axiosHelper";
import { sidebarSections } from "../../utilities/sidebarHelpers";

function HeaderAndFooterLayout() {
    const [sidenavOpen, setSidenavOpen] = useState(true);
    const [openSectionId, setOpenSectionId] = useState(() => {
        return sidebarSections[0]?.id || null;
    });
    const [navItems, setNavItems] = useState(null);
    const auth = useAuth();
    let currentOrganizationId = useStore((state) => state.CurrentOrganizationId);
    let config = useStore((state) => state.Configuration);

    const mainContentRef = useRef(null);

    // toggles collapse between mini sidenav and normal
    const toggleSidenav = (e) => {
        const isPinned = document.body.classList.contains("g-sidenav-pinned");

        if (isPinned) {
            document.body.classList.remove("g-sidenav-pinned");
            document.body.classList.add("g-sidenav-hidden");
        } else {
            document.body.classList.add("g-sidenav-pinned");
            document.body.classList.remove("g-sidenav-hidden");
        }

        // Sidebar state
        const nextState = !sidenavOpen;
        setSidenavOpen(nextState);

        // When opening for the first time, ensure a default section is open
        if (nextState && !openSectionId && sidebarSections?.length > 0) {
            setOpenSectionId(sidebarSections[0].id);
        }
    };


    const handleExpandFromCollapsed = (sectionId) => {
        // Expand sidebar and open specific section
        setSidenavOpen(true);
        setOpenSectionId(sectionId);
    };

    const location = useLocation();

    useEffect(() => {
        if (document?.documentElement != null) {
            document.documentElement.scrollTop = 0;
        }

        if (document?.scrollingElement?.scrollTop != null) {
            document.scrollingElement.scrollTop = 0;
        }

        mainContentRef.current.scrollTop = 0;
    }, [location]);

    useEffect(() => {
        async function loadNav() {
            if (auth.isLoading || !auth.isAuthenticated || auth?.user?.access_token == null)
                return;
            //get & populate nav items
            setAuthHeader(auth.user.access_token);
            const nav = await getNavItems(currentOrganizationId);
            setNavItems(nav.data);

        }
        
        loadNav();
    }, [auth, currentOrganizationId]);

    return (
        <>
            <Sidebar
                routes={routes(currentOrganizationId, config, navItems)}
                toggleSidenav={toggleSidenav}
                sidenavOpen={sidenavOpen}
                handleExpandFromCollapsed={handleExpandFromCollapsed}
                openSectionId={openSectionId}
                setOpenSectionId={setOpenSectionId}
                logo={{
                    innerLink: "/",
                    imgSrc: require("../../assets/img/brand/NCCO-logo-gray.png"),
                    imgAlt: "...",
                }}
            />
            <div className="main-content" ref={mainContentRef}>
                <AdminNavbar
                    theme="dark"
                    toggleSidenav={toggleSidenav}
                    sidenavOpen={sidenavOpen}
                />
                <Outlet />
            </div>
            {sidenavOpen ? (
                <div className="backdrop d-xl-none" onClick={toggleSidenav} />
            ) : null}
        </>
    );
}

export default HeaderAndFooterLayout;